import type { MetaFunction } from '@remix-run/node'
import { Container } from '~/application/components/Container/Container'
import { Content } from '~/application/components/Content/Content'
import Component from '~/application/data/privacy.mdx'
import { Heading } from '~/application/components/Heading/Heading'
import { getMeta } from '~/application/services/metaService'

export const meta: MetaFunction = ({ location }) => {
  return getMeta({
    title: 'プライバシーポリシー',
    url: location.pathname,
  })
}

export default function Privacy() {
  return (
    <>
      <Content>
        <Container size="sm">
          <div className="prose max-w-full">
            <Heading title="プライバシーポリシー" />
            <Component />
          </div>
        </Container>
      </Content>
    </>
  )
}
